import { useEffect, useState } from "react";
import React from "react";
import CustomButton from "../../../../../controls/CustomButton";
import AddQuestion from "./AddQuestion";
import DeleteIcon from "@mui/icons-material/Delete";
import CloseIcon from "@mui/icons-material/Close";
import EditIcon from "@mui/icons-material/Edit";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import { DragDropContext, Draggable, Droppable } from "react-beautiful-dnd";
import TextField from "@mui/material/TextField";
import useTitanApp from "../../../../../../hooks/useTitanApp";
import AddAiQuestion from "./AddAiQuestion";
import { MdOutlineModeEditOutline } from "react-icons/md";
import EditAiQuestion from "./EditAiQuestion";
function CustomAiTemplateSection({
  template,
  handleUpdateSection,
  handleDeleteSection,
  AddTemplateSection,
}) {
  const [isQuestion, setIsQuestion] = useState(false);
  const [editModalOpen, setEditModalOpen] = useState(false);
  const [questionToEdit, setQuestionToEdit] = useState(null);

  const handleOpenEditModal = (question) => {
    setQuestionToEdit(question);
    setEditModalOpen(true);
  };

  const handleUpdateQuestion = (updatedQuestion) => {
    const updatedUserControls = template?.userControls.map((control) =>
      control?.userControlId === updatedQuestion.userControlId
        ? updatedQuestion
        : control
    );

    const updatedTemplate = {
      ...template,
      userControls: updatedUserControls,
    };

    handleUpdateSection(updatedTemplate);
    setEditModalOpen(false);
    setQuestionToEdit(null);
  };

  function openQuestionModal() {
    setIsQuestion(true);
  }
  function handleCloseModal() {
    setIsQuestion(false);
  }
  function ChangeSectionTitle(e) {
    const newValue = e?.target?.value;
    const updatedTemplate = {
      ...template,
      sectionTitle: newValue,
    };
    handleUpdateSection(updatedTemplate);
  }
  function handleDeleteControl(objectToDelete) {
    const updatedUserControls = template?.userControls.filter(
      (control) => control !== objectToDelete
    );
    const updatedTemplate = {
      ...template,
      userControls: updatedUserControls,
    };
    handleUpdateSection(updatedTemplate);
  }
  function handleAddQuestion(obj) {
    const updatedTemplate = {
      ...template,
      userControls: [...template?.userControls, obj],
    };
    handleUpdateSection(updatedTemplate);
    setIsQuestion(false);
  }
  const handleDragEnd = (result) => {
    if (!result.destination) {
      return;
    }

    const reorderedQuestions = Array.from(template.userControls);
    const [moved] = reorderedQuestions.splice(result.source.index, 1);
    reorderedQuestions.splice(result.destination.index, 0, moved);

    const updatedTemplate = {
      ...template,
      userControls: reorderedQuestions,
    };
    handleUpdateSection(updatedTemplate);
  };

  return (
    <div className="medicine-card customcard drag_card">
      {editModalOpen && questionToEdit && (
        <EditAiQuestion
          isOpen={editModalOpen}
          handleCloseModal={() => setEditModalOpen(false)}
          editQuestion={questionToEdit}
          onEditQuestionSave={handleUpdateQuestion}
        />
      )}

      <AddAiQuestion
        isOpen={isQuestion}
        handleCloseModal={handleCloseModal}
        handleAddQuestion={handleAddQuestion}
      />
      <div className="temp_content">
        <div className="temp_head">
          <h4>Section</h4>
          <p className="sec_line">
            Use sections to break up the main part of your templates, and add
            questions to each section.
          </p>
        </div>
        <div className="temp_body">
          <div className="temp_body_a">
            <div className="template_control sec_name">
              <TextField
                className="text_input_field"
                id="outlined-required"
                value={template.sectionTitle}
                label="Title"
                required
                onChange={ChangeSectionTitle}
              />
            </div>

            <DragDropContext onDragEnd={handleDragEnd}>
              <Droppable
                droppableId={`questions-${template.groupId}`}
                type="question"
                direction="vertical"
              >
                {(provided) => (
                  <div {...provided.droppableProps} ref={provided.innerRef}>
                    {template?.userControls?.map((control, index) => (
                      <Draggable
                        key={control?.userControlId}
                        draggableId={control?.userControlId}
                        index={index}
                      >
                        {(provided, snapshot) => (
                          <>
                            <div
                              key={index}
                              className={`control_field ${
                                snapshot.isDragging ? "dragging-question" : ""
                              }`}
                              ref={provided.innerRef}
                              {...provided.draggableProps}
                              {...provided.dragHandleProps}
                            >
                              <span className="control_box">
                                {control.label}
                              </span>
                              <div className="control_field_actions">
                                <EditIcon
                                  fontSize="small"
                                  onClick={() => handleOpenEditModal(control)}
                                  style={{ marginLeft: 8 }}
                                  className="action_icon_clickable"
                                />
                                <DeleteIcon
                                  onClick={() => {
                                    handleDeleteControl(control);
                                  }}
                                  className="action_icon_clickable"
                                />
                              </div>
                            </div>
                          </>
                        )}
                      </Draggable>
                    ))}
                    {provided.placeholder}
                  </div>
                )}
              </Droppable>
            </DragDropContext>

            <div className="sec_footer">
              <CustomButton action={openQuestionModal} label="Add Question" />
            </div>
          </div>
          <div className="temp_body_b">
            <ContentCopyIcon
              onClick={() => {
                AddTemplateSection(true, template);
              }}
              className="action_icon_clickable"
            />

            <CloseIcon
              onClick={() => {
                handleDeleteSection(template);
              }}
              className="action_icon_clickable"
            />
          </div>
        </div>
      </div>
    </div>
  );
}

export default CustomAiTemplateSection;
